import { useQuery } from 'react-query';
import * as lookupsService from '../services/lookupsService';

const getStoreTypes = async () => {
    return await lookupsService.getStoreTypes();
}

export const useStoreTypeLookup = (options = {}) => {
    return useQuery({
        queryKey: ['storeTypes'],
        queryFn: getStoreTypes,
        ...options
    });
}

// Static lists, fetched once and shared by every card's pickers.
export const useProductIdentityValues = (options = {}) => {
    return useQuery({
        queryKey: ['productIdentityValues'],
        queryFn: () => lookupsService.getProductIdentityValues(),
        staleTime: Infinity,
        ...options
    });
}

// Static for the life of the page, and shared by every card's country pickers.
export const useCountryCodes = (options = {}) => {
    return useQuery({
        queryKey: ['countryCodes'],
        queryFn: () => lookupsService.getCountryCodes(),
        staleTime: Infinity,
        ...options
    });
}

export const useGovernorates = (options = {}) => {
    return useQuery({
        queryKey: ['governorates'],
        queryFn: () => lookupsService.getGovernorates(),
        staleTime: Infinity,
        ...options
    });
}

export const useCities = (governorateId?: string, options = {}) => {
    return useQuery({
        queryKey: ['cities', governorateId],
        queryFn: () => lookupsService.getCities(governorateId as string),
        enabled: !!governorateId,
        staleTime: Infinity,
        ...options
    });
}
